import getList from './getList';
import add from './add';
import edit from './edit';
import del from './del';
import getRole from './getRole';
import getVersion from './getVersion';
import getTypes from './getTypes';
export default {
  getList,
  add,
  edit,
  del,
  getRole,
  getVersion,
  getTypes,
};


// WEBPACK FOOTER //
// ./src/api/orchestrationinfos/index.ts